import axios from "axios";

export default {
    /**
     * 
     * @param {Object} obj 
     * @param {Number} obj.page - 当前页数
     * @param {Number} obj.row  - 每页多少条数据
     */
    getStudyList(obj) {
        return axios.post("/course/Study/getStudyList", obj);
    },
    /**
     * 
     * @param {Object} obj 
     * @param {String} obj.id 
     * @param {String} obj.type
     */
    getStudyDetail(obj) {
        return axios.post("/course/Study/getStudyDetail", obj);
    }
}